import { FormControl, MenuItem, Select, SelectChangeEvent, Tooltip } from "@mui/material";
import { Editor } from "@tiptap/react";
import { useState } from "react";

interface NoteTextStyleProps {
    editor: Editor;
    mode: number;
}

const HEADING_STYLES = [
  { label: 'Normal Text', value: 'paragraph' },
  { label: 'Title', value: 'heading', level: 1 },
  { label: 'Subtitle', value: 'heading', level: 2 },
  { label: 'Heading 1', value: 'heading', level: 3 },
  { label: 'Heading 2', value: 'heading', level: 4 },
  { label: 'Heading 3', value: 'heading', level: 5 },
];


export default function NoteTextStyle({ editor, mode }: NoteTextStyleProps) {
    const [noteTextStyle, setNoteTextStlye] = useState('Normal Text');

    const handleSelectHeadingStyle = (style: any) => {
        if (style.value === 'paragraph') {
            editor?.chain().focus().setParagraph().run();
        } else if (style.value === 'heading') {
            editor?.chain().focus().toggleHeading({ level: style.level as any }).run();
        }

        setNoteTextStlye(style.label);
    };

    return (
        <Tooltip title="Styles">
            <FormControl size="small" >
                <Select
                    value={noteTextStyle}
                    displayEmpty
                    sx={{
                        fontSize: '12px',
                        height: 32,
                        '& .MuiOutlinedInput-notchedOutline': {
                          border: 'none',
                        },
                        '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                          border: 'none',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          border: 'none',
                        },
                        '& .MuiSelect-icon': {
                            color: mode === 1 ? 'inherit' : 'white',
                        },
                        color: mode === 1 ? 'inherit' : 'white'
                    }}
                >
                    {HEADING_STYLES.map((style) => (
                        <MenuItem 
                            key={style.level} 
                            value={style.label}
                            onClick={() => handleSelectHeadingStyle(style)}
                        >
                        {style.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Tooltip>
    );
}
